import type { Enum } from './generics';

export const AuthErrorState = {
  Forbidden: 'forbidden',
  SessionExpired: 'session_expired',
} as const;

export type AuthErrorStateType = Enum<typeof AuthErrorState>;
